import { render, staticRenderFns } from "./SelectorCliente.vue?vue&type=template&id=270b734b"
import script from "./SelectorCliente.vue?vue&type=script&lang=js"
export * from "./SelectorCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports